export default function MetricCard({ label, value, sublabel, tone = "default", testId }) {
  const toneClass =
    tone === "gold" ? "gold" : tone === "danger" ? "danger" : tone === "success" ? "success" : "default";
  const valueColor =
    tone === "gold" ? "var(--gold-light)" : tone === "danger" ? "var(--danger)" : tone === "success" ? "var(--success)" : "var(--cream)";
  return (
    <div className="surface p-5" data-testid={testId} data-tone={toneClass}>
      <div
        className="text-[10px] tracking-[0.18em] uppercase font-mono-num"
        style={{ color: "var(--cream-muted)" }}
      >
        {label}
      </div>
      <div className="mt-3 kpi" style={{ color: valueColor }}>
        {value}
      </div>
      {sublabel && (
        <div className="mt-2 text-[11px]" style={{ color: "var(--cream-dim)" }}>
          {sublabel}
        </div>
      )}
    </div>
  );
}
